import { MiniSwiper } from 'global/components/swipers/MiniSwiper';
import _ from 'lodash';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { _matchLsTypes } from 'projectSpecific/sports/cnr/reducers/SportsDataReducer';
import { useContext, useMemo } from 'react';
import { _matchDisplayTypes } from '../matches/MatchContent';
import { MatchesDate } from '../matches/MatchesDate';
import { SectionDateHeader } from './SectionDateHeader';
import { SectionHeader } from './SectionHeader';
import { gEnums } from 'global/enums/globalEnums';

export const LevelSchedules = ({ teamKey }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { matches_info } = sportsSeason_state ?? {}
  const { matches_groupInfo } = matches_info ?? {}
  const { levelSectionDateMatches } = matches_groupInfo ?? {}

  const content_schedule_levelMatches = useMemo(() => {
    console.log('levelSectionDateMatches', levelSectionDateMatches)
    const _lsdms = _.omit(levelSectionDateMatches, [_matchLsTypes.Non, _matchLsTypes.nonDistrict, _matchLsTypes.nonSection])
    const levelItems = []
    _.forEach(_lsdms, (levelGroup, levelKey) => {
      const divs = []
      _.forEach(levelGroup, (dateGroup, dateKey) => {
        divs.push(<SectionDateHeader startDate={dateKey} matches={dateGroup} />)
        _.forEach(dateGroup, (sectionMatches, sectionKey) => {
          const _sectionHeader = <SectionHeader sectionKey={sectionKey} levelKey={levelKey} />
          const _sectionMatches = <MatchesDate
            dateKey={dateKey}
            levelKey={levelKey}
            matchDisplayType={_matchDisplayTypes.levelMatches}
            matches={sectionMatches}
            matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.levelTabsFull}
            sectionKey={sectionKey}
          />
          const div_section = <div className='match-date-matches'>
            {_sectionHeader}
            {_sectionMatches}
          </div>
          divs.push(div_section)
        })
      })
      levelItems.push(
        {
          key: levelKey,
          caption: levelKey,
          content: <div className='level-matches'>{divs}</div>
        }
      )
    })
    const _levelItems = _.sortBy(levelItems, 'key').reverse()
    return <MiniSwiper
      includeButtons={true}
      swipeItems={_levelItems}
      showButtons={true}
    />
  }, [levelSectionDateMatches])

  return content_schedule_levelMatches

}
